module.exports = __webpack_public_path__ + "media/images/lb/754-aefd27aa6197c859cfbd9f3bf9c6848d.svg";